import get from 'lodash/get';

export function getAnalyticsProperty(path: string, rejectTime = 3000): Promise<any> {
  return new Promise((resolve, reject) => {
    const intervalTime = 200;
    let count = 0;

    const interval = setInterval(() => {
      const analyticsProperty = get((window as any).analytics_ow, path);

      if (typeof analyticsProperty !== 'undefined') {
        clearInterval(interval);
        resolve(analyticsProperty);
      }

      if (count > rejectTime / intervalTime) {
        clearInterval(interval);
        reject('analytics property has not been found');
      }

      count++;
    }, intervalTime);
  });
}

export function waitForUserInteraction(): Promise<any> {
  return new Promise((resolve, reject) => {
    if (localStorage.getItem('uc_user_interaction') === 'true') resolve(true);
    else {
      document.addEventListener(
        'usercentrics-consents-updated',
        () => {
          if (localStorage.getItem('uc_user_interaction') === 'true') resolve(true);
          else reject('No consent given');
        },
        { once: true },
      );
    }
  });
}
